import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import config from '../../../config';
import useFetch from '../../../hooks/useFetch';
import { FAQS_ORDER } from '../mock/faqsOrder';
import { Title, Link } from '@npm-registry/eapteka-ui';
import './FaqOrder.scss';

export const FaqOrder = () => {
  const [status, setStatus] = useState('');
  const [delivery, setDelivery] = useState('');
  const [faqsOrder, setFaqsOrder] = useState(null);

  const itemOrder = document.querySelector('[data-order-number]');
  const orderId = Number(itemOrder.getAttribute('data-order-number'));
  const apiUrl = `${config.apiUrl.historyOrders}/${orderId}`;
  const [{ response }, doFetch] = useFetch(apiUrl, true);

  useEffect(() => {
    doFetch();
  }, [doFetch]);

  useEffect(() => {
    if (!response) {
      return;
    }

    const order = response.orders[0];

    setStatus(order.status_extended.code);
    setDelivery(order.delivery_type);
  }, [response]);

  useEffect(() => {
    const selectedDelivery = FAQS_ORDER.find(item => item.delivery === delivery);

    if (selectedDelivery) {
      const selectedFaqs = selectedDelivery.faqs.find(({ code }) => {
        return Array.isArray(code) ? code.includes(status) : status === code;
      });

      if (faqsOrder !== selectedFaqs && selectedFaqs) {
        setFaqsOrder(selectedFaqs);
      }
    }
  }, [delivery, faqsOrder, status]);

  return (
    <div className={clsx('FaqOrder', { 'FaqOrder_None': !faqsOrder })}>
      <Title className='FaqOrder_Title' tag='h3'>Вопросы и ответы по заказу</Title>
      <div className="FaqOrder_Articles">
        {
          faqsOrder && faqsOrder.faqs.map((faq, index) => {
            const { title, url } = faq;
            const urlRedirect = `${window.location.origin}${url}`;

            return <Link key={index} className='FaqOrder_Link' href={urlRedirect}>{title}</Link>;
          })
        }
      </div>
    </div>
  );
};
